/**
 * Modality Subscription Service
 */

import { api } from '../../lib/api'
import { API_ROUTES } from '../../config/constants'
import type {
  SubscriptionWithModality,
  SubscribedRadiologist,
  SubscriptionSummary,
} from '../../domain/modality/types'

export const subscriptionService = {
  /**
   * Get current user's subscriptions
   */
  getMySubscriptions: async (): Promise<{ subscriptions: SubscriptionWithModality[] }> => {
    const response = await api.get(API_ROUTES.STUDY_TYPE_SUBSCRIPTIONS.MY)
    return response.data
  },

  getUserSubscriptions: async (
    userId: string
  ): Promise<{ subscriptions: SubscriptionWithModality[] }> => {
    const response = await api.get(API_ROUTES.STUDY_TYPE_SUBSCRIPTIONS.BY_USER(userId))
    return response.data
  },

  subscribe: async (
    userId: string,
    studyTypeId: string
  ): Promise<{ message: string; subscription: SubscriptionWithModality }> => {
    const response = await api.post(API_ROUTES.STUDY_TYPE_SUBSCRIPTIONS.SUBSCRIBE(userId), {
      modalityId: studyTypeId,
    })
    return response.data
  },

  unsubscribe: async (userId: string, studyTypeId: string): Promise<void> => {
    await api.post(API_ROUTES.STUDY_TYPE_SUBSCRIPTIONS.UNSUBSCRIBE(userId, studyTypeId))
  },

  updateUserSubscriptions: async (
    userId: string,
    studyTypeIds: string[]
  ): Promise<{ message: string }> => {
    const response = await api.post(API_ROUTES.STUDY_TYPE_SUBSCRIPTIONS.UPDATE_ALL(userId), {
      modalityIds: studyTypeIds,
    })
    return response.data
  },

  getSummary: async (): Promise<{ summary: SubscriptionSummary[] }> => {
    const response = await api.get(API_ROUTES.STUDY_TYPE_SUBSCRIPTIONS.SUMMARY)
    return response.data
  },

  getSubscribers: async (
    studyTypeId: string
  ): Promise<{ subscribers: SubscribedRadiologist[] }> => {
    const response = await api.get(API_ROUTES.STUDY_TYPES.SUBSCRIBERS(studyTypeId))
    return response.data
  },
}
